// @flow
import React from "react";
import {SearchForm } from "./form";

import type {
    CruiseSearchType
} from "../../flow/api_types";
import CruiseDriver from "./cruise-driver";

type SearchTemplateResultsProps = {
    solo: boolean,
    searchParams: CruiseSearchType,
    resultsPerRow: number,
}

type SearchTemplateResultsState = {
    searchParams: CruiseSearchType,
}

export default class SearchTemplateResults extends React.Component<SearchTemplateResultsProps, SearchTemplateResultsState> {
    constructor(props: SearchTemplateResultsProps) {
        super(props);

        this.state = {
            searchParams: this.props.searchParams
        };
    }

    getDefaultProps = () => {
        return {
            solo: false,
            resultsPerRow: 3,
        }
    }

    getConfig = () => { return  {
        results: {
            'renderMethod': this.renderResults,
        },
    }};

    getResultClassName = () =>`columns small-12 medium-${12/ this.props.resultsPerRow}`;


    renderResults = (propertyPath: string, form: Object, config: Object): Array<React$Element<*>> => {
        return Object.keys(form.state.results).map(item => <div key={ form.state.results[item].id } className={this.getResultClassName()}><CruiseDriver solo={ this.props.solo } grid={ true } {...form.state.results[item]} /></div> )
    };

    renderTemplate = (formFields: Object): React$Element<*> => {
        return (
            <div className="row cruise-driver--equalise-container">
                { formFields.results }
            </div>
        )
    };

    render() {
        return (
            <SearchForm template={ this.renderTemplate } config={ this.getConfig() } searchParams={ this.state.searchParams } useAnalytics={false} />
        )
    }
}



